import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "rs_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, kind = "component", qty = 1) => {
    setItems((cur) => {
      const idx = cur.findIndex((c) => c.item_id === product.id && c.kind === kind);
      if (idx >= 0) {
        const next = [...cur];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        return next;
      }
      return [...cur, {
        item_id: product.id,
        kind,
        name: product.name,
        unit_price_inr: product.selling_price_inr,
        quantity: qty,
      }];
    });
  };

  const update = (item_id, kind, qty) =>
    setItems((cur) => cur.map((c) => (c.item_id === item_id && c.kind === kind ? { ...c, quantity: Math.max(1, qty) } : c)));

  const remove = (item_id, kind) =>
    setItems((cur) => cur.filter((c) => !(c.item_id === item_id && c.kind === kind)));

  const clear = () => setItems([]);

  const total = useMemo(() => items.reduce((s, i) => s + i.unit_price_inr * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartCtx.Provider value={{ items, add, update, remove, clear, total, count }}>
      {children}
    </CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx);
